<!-- Caso exista uma imagem definida, então, deve-se exibir esta imagem como avatar. -->
<!--<a *ngIf="image()" href="#" (click)="onClick($event)">-->
<!--    <img [src]="image()" class="avatar-rounded-image" [style.width]="size()" [style.minHeight]="size()">-->
<!--</a>-->

<!-- Caso nenhuma imagem seja definida, o fallback é as letras informadas (letters) -->

@if (!image() && !base64()) {
    <button
        [ngClass]="{ 'avatar-rounded': true }"
        (click)="onClick($event)"
        [style.width]="size()"
        [style.minHeight]="size()"
        [style.fontSize]="fontSize()"
    >
        {{ letters() }}
    </button>
} @else {
    <button
        [ngClass]="{ 'avatar-rounded': true }"
        [style.backgroundImage]="backgroundImage()"
        (click)="onClick($event)"
        [style.width]="size()"
        [style.minHeight]="size()"
        [style.fontSize]="fontSize()"
    ></button>
}
